import { createClient, Transport } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { ReceiptUploadService } from '../../generated/receipt/v1/receipt_pb';
import { ReportsService } from '../../generated/reports/v1/reports_pb';
import { ShoppingListService } from '../../generated/shopping/v1/shopping_pb';
import { API_BASE_URL } from '../utils/config';
import { authInterceptor } from './authInterceptor';

// Create transport with ConnectRPC protocol (backend expects JSON format)
const transport: Transport = createConnectTransport({
  baseUrl: API_BASE_URL,
  // Use JSON format - backend expects application/json
  useBinaryFormat: false,
  // Add auth interceptor to inject JWT tokens and handle refresh
  interceptors: [authInterceptor],
});

// Create typed clients
export const receiptClient = createClient(
  ReceiptUploadService,
  transport
);

export const reportsClient = createClient(
  ReportsService,
  transport
);

export const shoppingListClient = createClient(
  ShoppingListService,
  transport
);
